import { Box, Heading } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import SkeletonContainer from '../../SkeletonContainer';

const SkeletonReply = (): JSX.Element => {
  return (
    <>
      <Bone type="line" css={{ width: '33.33%', marginBottom: 'default' }} />
      <Bone type="line" css={{ marginBottom: 'default' }} />
      <Box css={{ marginBottom: 'default' }} />
    </>
  );
};

const Skeleton = (): JSX.Element => {
  return (
    <SkeletonContainer>
      <>
        <Heading level={2} textStyle="heading-xs" css={{ marginTop: 'default', marginBottom: 'default' }}>
          My replies
        </Heading>

        <SkeletonReply />
        <SkeletonReply />
        <SkeletonReply />
        <SkeletonReply />
        <SkeletonReply />
      </>
    </SkeletonContainer>
  );
};

export default Skeleton;
